// This import loads the firebase namespace along with all its type information.
import ContentCreatorInvite from './content-creator-invite-model'

export async function load_contentCreatorInvites(): Promise<
  ContentCreatorInvite[]
> {
  throw 'Not implemented'
}

export async function delete_contentCreatorInvite(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentCreatorInvite(): Promise<ContentCreatorInvite> {
  throw 'Not implemented'
}
